module.exports = __webpack_public_path__ + "static/cicada_logo1-6bb12651e9bd4e083097e8f0c43a1bcb.png";